import { render, staticRenderFns } from "./BountyCard.vue?vue&type=template&id=48170344&scoped=true"
import script from "./BountyCard.vue?vue&type=script&lang=js"
export * from "./BountyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48170344",
  null
  
)

export default component.exports